const { webmd, Medscape } = window;
function injectIfiAd() {
    const sizes = [1, 1];
    let container = document.body;
    let adContainer = document.createElement('div');
    adContainer.classList.add("AdUnit");
    container.appendChild(adContainer);
    if (ENV === "development") {
        //let iframe = document.createElement('iframe');
        //document.body.appendChild(iframe);
        //iframe.src = "https://ads.localhost.com:4040/html/ads/mtv-ifi.html";
        adContainer.innerHTML = `<iframe src="https://ads.localhost.com:4040/html/ads/mtv-ifi.html"></iframe>`;

    } else if (Medscape.isMobile === true || Medscape.isIcd === true) {
        if(typeof window.ads2_ignore !== 'undefined' && typeof window.ads2_ignore[1800] !== 'undefined') {
            delete window.ads2_ignore[1800];
        }
        const adId = 'ads-pos-1800';
        const pos = 1800; 
        adContainer.setAttribute("id", adId);
        
        webmd.ads2.defineAd({
            id: adId,
            pos: pos,
            sizes: sizes,
            collapseBefore: true,
            collapseAfter: true
        }).refresh({ id: adId });
    } else {
        const adId = 'ads-pos-800';
        const pos = 800;
        adContainer.setAttribute("id", adId);
        webmd.ads2.defineAd({
            id: adId,
            pos: pos,
            sizes: sizes,
            collapseBefore: true,
            collapseAfter: true
        }).refresh({ id: adId });

    }
}
export default injectIfiAd;